import React from "react";
import { Dropdown } from "react-bootstrap";
import { FaComment, FaEnvelope, FaFileCsv, FaFilePdf, FaFileExcel } from "react-icons/fa";

const Actions = () => {
    return (
        <div className="flex-grow-sm-0">
            <Dropdown>
                <Dropdown.Toggle
                    id="action-dropdown"
                    className="btn btn-gray text-start w-100 d-flex align-items-center justify-content-between px-4 py-2 border-0 rounded-3 shadow-sm dropdownbtn"
                >
                    <span>Action</span>
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdown-menu w-100 bg-white fs-sm fw-semibold border-0 rounded-3 shadow-sm mt-2">
                    <Dropdown.Item className="dropdown-item d-flex align-items-center gap-2 py-2">
                        <FaComment className="icon-sm" />
                        <span>Send Chat</span>
                    </Dropdown.Item>
                    <Dropdown.Item className="dropdown-item d-flex align-items-center gap-2 py-2">
                        <FaEnvelope className="icon-sm" />
                        <span>Send Mail</span>
                    </Dropdown.Item>
                    <Dropdown.Item className="dropdown-item d-flex align-items-center gap-2 py-2">
                        <FaFileCsv className="icon-sm" />
                        <span>CSV</span>
                    </Dropdown.Item>
                    <Dropdown.Item className="dropdown-item d-flex align-items-center gap-2 py-2">
                        <FaFilePdf className="icon-sm" />
                        <span>PDF</span>
                    </Dropdown.Item>
                    <Dropdown.Item className="dropdown-item d-flex align-items-center gap-2 py-2">
                        <FaFileExcel className="icon-sm" />
                        <span>Excel</span>
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

export default Actions;